<template>
  <section class="publication-single">
    <EventsSingleHeader :publication="publication" />
    <EventsSingleContent v-if="publication && publication.content" :publication="publication" />
    <EventsSingleMore v-if="publication" :publication="publication" />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'EventsSingle',
  components: { ...partials },
  props: {
    eventSlug: String
  },
  computed: {
    publication() {
      if (!this.$wp.secondaryDataLoaded) return null
      return this.$wp.events[this.eventSlug] || null
    }
  },
  mounted() {
    this.$watch(
      '$wp.secondaryDataLoaded',
      isLoaded => {
        if (isLoaded) {
          console.log('Event loaded:', this.publication)
        }
      },
      { immediate: true }
    )
  }
}
</script>
